
import { separator, defaultStyles } from '../..';
import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
    title: {
        fontWeight: 'normal',
    },
    separator: {
        ...separator,
    },
});

export default styles;
